import { createFileRoute, useParams } from '@tanstack/react-router';

import { PractitionerEditScreen } from '@/features/practitioners/components/workspace/PractitionerEditScreen';
import { requirePermission } from '@/lib/guards';

export const Route = createFileRoute('/_staff/admin/workspace/practitioners/$practitionerId/edit')({
  beforeLoad: () => {
    requirePermission('practitioner:update');
  },
  component: WorkspacePractitionerEditRoute,
  staticData: { crumb: 'Edit' },
});

function WorkspacePractitionerEditRoute() {
  const { practitionerId } = useParams({
    from: '/_staff/admin/workspace/practitioners/$practitionerId/edit',
  });
  return <PractitionerEditScreen practitionerId={practitionerId} />;
}
